import { Platform } from "react-native";

export const usePlatformStyles = (): { webOutlineNone: any } => ({
  webOutlineNone: Platform.OS === "web" ? { outlineStyle: "none" } : undefined
});
